module.exports = __webpack_public_path__ + "img/retired-min.0e37277f.jpg";